import React, { useContext, useState } from "react";
import BookOutline from "../Assets/Icon/BookOutline";
import HeadphoneLight from "../Assets/Icon/HeadphoneLight";
import Heart2Icon from "../Assets/Icon/Heart2Icon";
import logo from "../Assets/Images/logo.png";
import NavItem from "./NavItem";
import Close from "../Assets/Icon/Close";
import PlayIcon from "../Assets/Icon/PlayIcon";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { GlobalState } from "../Helper/Context";
import RemoveIcon from "../Assets/Icon/RemoveIcon";
const Header = () => {
  const { state, setState } = useContext(GlobalState);
  const [top, setTop] = useState(false);
  const [showFav, setShowFav] = useState({
    show: false,
  });
  window.onscroll = (e) => {
    window.scrollY > 0 ? setTop(true) : setTop(false);
  };
  const reload = useNavigate();
  const location = useLocation();
  return (
    <div className="header shadow-sm mb-8">
      <header
        className={`nav container m-auto h-[60px] flex items-center justify-between px-8 md:px-4 ${
          state.langTo === "EN" && "notranslate"
        }`}
      >
        <Link to="/QuranApp">
          <img src={logo} alt="waratel logo" className=" w-32" />
        </Link>
        <nav
          className={`flex items-center justify-evenly h-16 rounded-b-3xl gap-8 fixed container bg-white z-10 left-1/2 -translate-x-1/2 shadow-sm transition-all sm:top-0 sm:shadow-none sm:relative sm:justify-center sm:h-auto sm:transform-none sm:left-auto ${
            top ? "top-0" : "top-[60px]"
          }`}
        >
          <NavItem
            icon={<HeadphoneLight />}
            text={state.langTo === "EN" ? "الإستماع" : "Listening"}
            link="/QuranApp"
          />
          <NavItem
            icon={<BookOutline />}
            text={state.langTo === "EN" ? "التحفيظ" : "Memorization"}
            link="/save"
          />
        </nav>
        <div className="flex gap-4 items-center notranslate">
          {(location.pathname === "/save" ||
            location.pathname === "/QuranApp" ||
            location.pathname === "/QuranApp/") && (
            <Heart2Icon
              className=" cursor-pointer"
              onclick={() => setShowFav({ ...showFav, show: !showFav.show })}
            />
          )}
          <span
            className="cursor-pointer w-5"
            onClick={() => {
              localStorage.setItem(
                "langTo",
                state.langTo === "EN" ? "AR" : "EN"
              );
              setState({ ...state, langTo: localStorage.langTo });
            }}
          >
            {state.langTo}
          </span>
        </div>
      </header>

      {showFav.show && (
        <div
          className="backdrop fixed w-screen h-screen  bg-black z-10 top-0 left-0 opacity-30"
          onClick={() => setShowFav({ ...showFav, show: !showFav.show })}
        ></div>
      )}
      <div
        className={`favList container fixed w-[min(95vw,1200px)] h-[80vh] rounded-3xl left-1/2 -translate-x-1/2 z-20 bg-[#F5F7F9] overflow-auto transition-all ${
          showFav.show
            ? "bottom-[10vh] opacity-100"
            : "bottom-[-20vh] opacity-0 pointer-events-none"
        }`}
      >
        <div className="holder flex justify-between px-4 pt-4 gap-4 border-b py-2 items-center sticky top-0 bg-white">
          <div className="flex">
            <span className="cursor-pointer py-1 px-2 rounded-xl bg-[var(--MColor)] text-white">
              {location.pathname === "/save"
                ? state.langTo === "EN"
                  ? "الآيات المفضلة"
                  : "Favorite Verses"
                : state.langTo === "EN"
                ? "السور المفضلة"
                : "Favorite Surah"}
            </span>
          </div>
          <Close
            onclick={() => setShowFav({ ...showFav, show: !showFav.show })}
          />
        </div>
        <ol className="px-4">
          <li className="py-2 flex items-center max-w-lg border-b">
            <span className=" w-48 flex items-start gap-4">
              {state.langTo === "EN" ? "اسم السورة" : "Surah Name"}
            </span>
            <span className=" w-48">
              {location.pathname === "/save"
                ? state.langTo === "EN"
                  ? "رقم الآية"
                  : "Verse Number"
                : state.langTo === "EN"
                ? "عدد الآيات"
                : "Verses Number"}
            </span>
            <span>{state.langTo === "EN" ? "إزالة" : "remove"}</span>
          </li>
          {location.pathname === "/save"
            ? JSON.parse("[" + state.favVerse + "]").map((verse) => {
                return (
                  <li
                    className="py-2 flex items-center max-w-lg"
                    key={verse.number}
                  >
                    <span
                      className={`w-48 flex items-start gap-4 cursor-pointer ${
                        state.selectedVerse === verse.numberInSurah &&
                        "text-[var(--MColor)]"
                      }`}
                      onClick={() => {
                        setState({
                          ...state,
                          selectedVerse: verse.numberInSurah,
                        });
                        localStorage.setItem(
                          "selectedVerse",
                          JSON.stringify(verse.numberInSurah)
                        );
                      }}
                    >
                      <PlayIcon
                        fill={
                          state.selectedVerse === verse.numberInSurah &&
                          "#00ad67"
                        }
                      />
                      {state.langTo === "EN"
                        ? verse.surah.name
                            .replace(/[\u064B-\u065F|\u06E1]/g, "")
                            .replaceAll("ٱ", "ا")
                            .replaceAll("ىٰ", "ى")
                            .replaceAll("مٰ", "م")
                        : verse.surah.englishName}
                    </span>
                    <span className=" w-48">
                      {state.langTo === "EN" ? "آية " : " Verse "}
                      {verse.numberInSurah}
                    </span>
                    <div
                      className="remove cursor-pointer"
                      onClick={() => {
                        localStorage.favVerse = localStorage.favVerse
                          .replace("," + JSON.stringify(verse), "")
                          .replace(JSON.stringify(verse) + ",", "")
                          .replace(JSON.stringify(verse), "");
                        setState({ ...state, favVerse: localStorage.favVerse });
                      }}
                    >
                      <RemoveIcon />
                    </div>
                  </li>
                );
              })
            : JSON.parse("[" + state.favSurah + "]").map((surah) => {
                return (
                  <li
                    className="py-2 flex items-center max-w-lg"
                    key={surah.number}
                  >
                    <span
                      className={`w-48 flex items-start gap-4 cursor-pointer ${
                        state.selectedSurah.number === surah.number &&
                        "text-[var(--MColor)]"
                      }`}
                      onClick={() => {
                        setState({ ...state, selectedSurah: surah });
                        localStorage.setItem(
                          "selectedSurah",
                          JSON.stringify(surah)
                        );
                      }}
                    >
                      <PlayIcon
                        fill={
                          state.selectedSurah.number === surah.number &&
                          "#00ad67"
                        }
                      />
                      {state.langTo === "EN"
                        ? surah.name
                            .replace(/[\u064B-\u065F|\u06E1]/g, "")
                            .replaceAll("ٱ", "ا")
                            .replaceAll("ىٰ", "ى")
                            .replaceAll("مٰ", "م")
                        : surah.englishName}
                    </span>
                    <span className=" w-48">
                      {surah.numberOfAyahs}
                      {state.langTo === "EN" ? " آية" : " Verse"}
                    </span>
                    <div
                      className="remove cursor-pointer"
                      onClick={() => {
                        localStorage.setItem(
                          "favSurah",
                          JSON.stringify(
                            JSON.parse(`[${localStorage.favSurah}]`).filter(
                              (item) => item.number !== surah.number
                            )
                          )
                            .replace("[", "")
                            .replace("]", "")
                        );
                        setState({ ...state, favSurah: localStorage.favSurah });
                      }}
                    >
                      <RemoveIcon />
                    </div>
                  </li>
                );
              })}
        </ol>
      </div>
    </div>
  );
};

export default Header;
